module.controller('userDetailCreateCtrl', [ '$scope', '$rootScope', '$state', 'userService', 'alertService', 'roleService', 'parameterService', userDetailCreateCtrlFn ]);
function userDetailCreateCtrlFn($scope, $rootScope, $state, userService, alertService, roleService, parameterService) {

	$scope.operationType = $state.current.data.type;
	$scope.idUser = null;
	$scope.user = {
		visible : true,
		client : {}
	};
	$scope.loading = false;

	$scope.sendAction = function() {
		$scope.create();
	};

	/**
	 * 
	 */
	$scope.create = function() {
		alertService.showSwtQuestion('Crear Usuario', createUser);
	};

	function createUser() {
		$scope.loading = true;

		var createModel = {
			username : $scope.user.username,
			firstName : $scope.user.firstName,
			lastName : $scope.user.lastName,
			email : $scope.user.email,
			password : $scope.user.password
		};

		console.log(createModel)
		
		userService.createUser(createModel).then(function(response) {
			$scope.loading = false;
			alertService.showSuccess('Usuario creado satisfactoriamente');
			$state.go('home.userList');
		}, function(response) {
			$scope.loading = false;
		});
	}
}
